// Canlı filo listesi/harita araması — yalnızca ekranda yazan plaka.
// snapshot.plate ile vehicle.plate farklıysa OR yapmak, görünen plakası
// uymayan araçları (ör. 07 C 0187) "2262" aramasında bırakıyordu.

export function normalizePlateQuery(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
}

export function snapshotDisplayPlate(snapshot) {
  return snapshot?.plate || snapshot?.vehicle?.plate || "";
}

export function snapshotMatchesPlateSearch(snapshot, query) {
  const q = normalizePlateQuery(query);
  if (!q) return true;
  return normalizePlateQuery(snapshotDisplayPlate(snapshot)).includes(q);
}
